import portal from '~/net/portal'

export default async function(context, next) {
    if (process.server) {
        const [resp1, resp2] = await Promise.all([portal.getUserInfo({ client: context.req }), portal.identities({ client: context.req })].map(p => p.catch(e => e))).catch(e => console.log(e))
        context.user = resp1?.data || null
        context.identities = resp2?.data || null
        context.store.commit('SET_USER', context.user)
        context.store.commit('SET_IDENTITY', context.identities)
        if (context.user&&context.user.passwordRegular == false) {
            context.store.commit('SET_PWDVISIBLE', true)
        }
        next()
    } else {
        next()
    }
}
